module.exports = __webpack_public_path__ + "img/globe-02.d83944ae.svg";